import React, { useMemo } from 'react';

import Content from 'components/Globals/Layout/StubPage/Content';
import { withSnackbar } from 'components/SnackbarNotification';
import { SECTIONS, COMPONENTS } from 'components/Globals/Analytics/constants';

import useDeviceTypeLayouts from 'utils/hooks/useDeviceTypeLayouts';

import About from 'components/Productions/Display/QuickView/About';
import Reviews from 'components/Productions/Display/QuickView/Reviews';
import Videos from 'components/Productions/Display/QuickView/Videos';
import Photos from 'components/Productions/Display/QuickView/Photos';
import NavigationTabs from 'components/Productions/Display/QuickView/NavigationTabs';
import CastAndCrew from 'components/Productions/Display/QuickView/CastAndCrew';
import ProgramList from 'components/Productions/Display/QuickView/ProgramList';

import ProductionStubInfo from '../ProductionStubInfo';
import { useStickyHeader } from '../QuickView/StickyHeader';
import MobileProductionStubPage from '../MobileProductionStubPage';
import VenuesList from '../VenuesList';

const Home = ({ entity, entityType }) => {
  const { isMobile } = useDeviceTypeLayouts();
  const { stickyElements, navigationTabsRef } = useStickyHeader();

  const sections = useMemo(() => {
    const stats = entity?.stats || {};
    let components = [];

    if (isMobile) {
      components = [
        {
          component: MobileProductionStubPage,
          showSection: true,
        },
      ];

      return components;
    }

    components = [
      {
        component: ProductionStubInfo,
        showSection: true,
        trackingData: {},
        sectionProps: {
          marginTopSmall: true,
        },
        props: {
          stickyElements,
        },
      },
      {
        component: NavigationTabs,
        props: {
          trackingData: {},
          isDesktopStubPage: true,
          ref: navigationTabsRef,
        },
        sectionProps: {
          marginTopSmall: true,
        },
        showSection: true,
      },
      {
        component: CastAndCrew,
        props: {
          trackingData: {},
          isDesktopStubPage: true,
        },
        sectionProps: {
          marginTopSmall: true,
        },
        showSection: true,
      },
      {
        component: ProgramList,
        props: {
          trackingData: {},
          isDesktopStubPage: true,
        },
        showSection: entity?.productionWorks?.length > 1,
      },
      {
        component: Reviews,
        props: {
          isOverview: true,
          limit: 9,
          isDesktopStubPage: true,
          trackingData: {
            section: SECTIONS.GENERAL_REVIEWS,
            component: COMPONENTS.REVIEW_CARD,
          },
        },
        sectionProps: {
          marginTopSmall: true,
          enableSeeAll: false,
        },
        showSection: stats?.reviews?.exists,
      },
      {
        component: Videos,
        props: {
          isDesktopStubPage: true,
          trackingData: {
            section: SECTIONS.VIDEOS_LISTING,
          },
        },
        sectionProps: {
          marginTopSmall: true,
        },
        showSection: stats?.media?.videos?.exists,
      },
      {
        component: Photos,
        props: {
          trackingData: {
            section: SECTIONS.PHOTOS_LISTING,
          },
          isDesktopStubPage: true,
        },
        sectionProps: {
          marginTopSmall: true,
        },
        showSection: true,
      },
      {
        component: About,
        props: {
          trackingData: {
            section: SECTIONS.ABOUT,
          },
          isDesktopStubPage: true,
        },
        sectionProps: {
          marginTopSmall: true,
        },
        showSection: stats?.about?.exists,
      },
      {
        component: VenuesList,
        props: {
          trackingData: {
            section: SECTIONS.VENUES,
            component: COMPONENTS.VENUE_CARD,
          },
        },
        sectionProps: {
          marginTopSmall: true,
        },
        showSection: stats?.reviews?.exists,
      },
    ];

    return components;
  }, [entity?.stats, isMobile, stickyElements, navigationTabsRef]);

  return <Content entity={entity} entityType={entityType} sections={sections} />;
};

export default withSnackbar(Home);
